import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';

export default class EnableModal extends Component {
    render() {
        const { show, handleSubmit, handleClose, isActive } = this.props;
        const text = isActive?'Desabilitar':'Habilitar'
        return (
            <Modal
                animation={false}
                show={show}
                onHide={handleClose}
                className="modal"
                dialogClassName="modal-lg modal-dialog-centered"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-400 fs-14">{text} Terminal</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                  <div className="alert alert-danger rounded-0 mb-0">
                    Você tem certeza que gostaria de {text} esse terminal?
                  </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-success btn-outline" onClick={handleSubmit}>Sim</button>
                    <button type="button" className="btn btn-danger btn-outline" onClick={handleClose}>Não</button>
                </Modal.Footer>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Terminals/Enable/Modal.js